const podcasts_en = require('./podcasts.json')
export default podcasts_en